/**
 * The three panels an item's page can show, and which of them apply.
 *
 * Only an event carries attributes of its own, so only an event has that
 * third panel. A URL asking for a panel the item does not have is not an
 * error: the usage panel is what everything has, so that is where it lands.
 */

export const DATA_INDEX_ITEM_TABS = ['usage', 'activity', 'attributes'] as const;

export type DataIndexItemTab = (typeof DATA_INDEX_ITEM_TABS)[number];

export const DEFAULT_ITEM_TAB: DataIndexItemTab = 'usage';

export type DataIndexItemTabOption = {
  value: DataIndexItemTab;
  label: string;
  /** The count beside the label, or nothing where there is none to give. */
  badge: string | undefined;
};

/** The panel a URL asks for, or the default when it asks for one that does not apply. */
export function resolveItemTab(requested: string | null | undefined, withEventAttributes: boolean): DataIndexItemTab {
  const tab = DATA_INDEX_ITEM_TABS.find((known) => known === requested);

  if (tab == null || (tab === 'attributes' && !withEventAttributes)) {
    return DEFAULT_ITEM_TAB;
  }
  return tab;
}

export type ItemTabCounts = {
  usage: number;
  eventAttributes: number;
};

export function itemTabs(counts: ItemTabCounts, withEventAttributes: boolean): DataIndexItemTabOption[] {
  const tabs: DataIndexItemTabOption[] = [
    { value: 'usage', label: 'Usage', badge: String(counts.usage) },
    { value: 'activity', label: 'Activity', badge: undefined },
  ];

  if (withEventAttributes) {
    tabs.push({ value: 'attributes', label: 'Event Attributes', badge: String(counts.eventAttributes) });
  }

  return tabs;
}
